function checkAngularRoute(routeObj) {
    var angularRoutes = configData.activeAngularRoutes;
    if (routeObj.template && routeObj.templateUrl) {
        if (angularRoutes && angularRoutes.indexOf(routeObj.path) > -1) {
            delete routeObj.templateUrl;
            delete routeObj.controller;
            delete routeObj.controllerAs;
        }
        else {
            delete routeObj.template;
        }
    }
}

/**
 * Use this file to define global variables and function. Be carefully and think twice if it's really necessary!
 *
 * @type {{isDefined: impactX.isDefined, dataSize: impactX.dataSize}}
 */
var impactX = {
    startTrackingTime: function () {
        this.startTime = new Date().getTime();
    },
    endTrackingTime: function () {
        var time = new Date().getTime() - this.startTime;
        console.log(time);
        angular.element(".timeTrackerWrapper").remove();
        angular
            .element("body")
            .append('<div class="timeTrackerWrapper">' + time + "ms</div>");
    },
    getWatchers: function (root) {
        root = angular.element(root || document.documentElement);
        var watcherCount = 0;

        function getElemWatchers(element) {
            var isolateWatchers = getWatchersFromScope(
                element.data().$isolateScope
            );
            var scopeWatchers = getWatchersFromScope(element.data().$scope);
            var watchers = scopeWatchers.concat(isolateWatchers);
            angular.forEach(element.children(), function (childElement) {
                watchers = watchers.concat(
                    getElemWatchers(angular.element(childElement))
                );
            });
            return watchers;
        }

        function getWatchersFromScope(scope) {
            if (scope) {
                return scope.$$watchers || [];
            } else {
                return [];
            }
        }

        return getElemWatchers(root);
    },
    /**
     * Checks if a property exists on the given object. returns the property if it exists, otherwise undefined
     *
     * @param baseObject object to test
     * @param propertyKey describes the path to the property
     * @return {*} property if it exists, otherwise undefined
     */
    isDefined: function (baseObject, propertyKey) {
        return propertyKey
            .split(".")
            .reduce(function (nestedObject, nestedKey) {
                return typeof nestedObject === "undefined" ||
                    nestedObject === null
                    ? nestedObject
                    : nestedObject[nestedKey];
            }, baseObject);
    },
    /**
     * Checks if a function exists on/in the given object. Returns boolean value.
     *
     * @param baseObject object to test
     * @param propertyKey describes the path to the function
     * @return {Boolean} true if the function exists, false in all other cases.
     */
    isFunction: function (baseObject, propertyKey) {
        var pathIdx, propertyName, propertyPathEntries, lastPathResult;

        if (baseObject && typeof propertyKey === "string") {
            propertyPathEntries = propertyKey.split(".");

            for (pathIdx = 0; pathIdx < propertyPathEntries.length; pathIdx++) {
                propertyName = propertyPathEntries[pathIdx];

                if (pathIdx === 0) {
                    //Special treatment for the first
                    if (propertyName && baseObject[propertyName]) {
                        lastPathResult = baseObject[propertyName];
                    } else {
                        return false;
                    }
                } else {
                    if (lastPathResult) {
                        if (propertyName && lastPathResult[propertyName]) {
                            lastPathResult = lastPathResult[propertyName];
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                }
            }

            return typeof lastPathResult === "function";
        }
        //
        return typeof baseObject === "function";
    },
    isFunc: function(func) {
        return typeof func === 'function';
    },
    isEmptyObject: function (objectToTest) {
        var propertyKey;

        if (objectToTest === null) {
            return true;
        }

        if (objectToTest.length > 0) {
            //array check
            return false;
        }

        if (typeof objectToTest === "object") {
            for (propertyKey in objectToTest) {
                if (objectToTest.hasOwnProperty(propertyKey)) {
                    return false;
                }
            }
        }

        return true;
    },
    isJsObject: function (obj) {
        return obj && typeof obj === "object" && !Array.isArray(obj);
    },

    isObject: function (objValue) {
        return objValue && typeof objValue === 'object' && objValue.constructor === Object;
    },

    /**
     * Retrieves the width of the element.
     *
     * @param elementId element ID (without # prefix)
     */
    elementWidth: function (elementId) {
        var elem;
        if (elementId) {
            elem = angular.element(document.getElementById(elementId));
            if (elem) {
                return elem.prop("offsetWidth");
            }
        }
    },
    /**
     * Converts a list with (possible) strings to a list of integers.
     *
     * @param someList list with (possible) strings representing numbers.
     * @return {Array} an array with numbers (integers)
     */
    toIntegerList: function (someList) {
        var idx,
            origValue,
            resultItem,
            result = [];

        if (someList && someList.length) {
            for (idx = 0; idx < someList.length; idx++) {
                origValue = someList[idx];
                //Checks ...
                if (typeof origValue === "number") {
                    if (!isNaN(origValue)) {
                        result.push(origValue);
                    }
                } else if (typeof origValue === "string") {
                    resultItem = parseInt(origValue, 10);

                    if (!isNaN(resultItem)) {
                        result.push(resultItem);
                    }
                }
            }
        }

        return result;
    },
    /**
     * Tries to extract the value for the given object and the given property key. If nothing can be extracted or
     * the extracted value is undefined or null, then the default value is used.
     *
     * @param baseObject base object to use
     * @param propertyKey property key/path in the base object
     * @param defaultValue default value to use if needed
     * @return {*} property if it exists or the default value.
     */
    valueOrDefault: function (baseObject, propertyKey, defaultValue) {
        return propertyKey
            .split(".")
            .reduce(function (nestedObject, nestedKey) {
                return typeof nestedObject === "undefined" ||
                    nestedObject === null
                    ? defaultValue
                    : nestedObject[nestedKey];
            }, baseObject);
    },
    /**
     * Calculates size for given object. ONLY FOR DEBUGGING data size send to backend.
     *
     * @param data data to get size for.
     * @param unit unit to use.
     * @return {*} size
     */
    dataSize: function (data, unit) {
        var size,
            divisor = 1;
        if (data) {
            size = JSON.stringify(data).length;
            if (unit) {
                unit = unit.toLowerCase();
                unit = unit.trim();
            }

            if (unit == "kb") {
                divisor = 1024;
            }

            size = Math.ceil(size / divisor);

            return size.toFixed(0);
        }
        return 0;
    },
    docFiles: ["doc", "docx", "odt"],
    excelFiles: ["xls", "xslt", "ods", "xlsx"],
    pdfFiles: ["pdf"],
    xmlFiles: ["xml"],
    imageFiles: ["png", "jpg", "jpeg", "bmp", "gif", "tif", "img", "psd"],
    pptFiles: ["ppt", "pptx", "odp"],
    whiteListFiles: ["doc", "docx", "odt", "xls", "xslt", "ods", "xlsx", "pdf", "png", "jpg", "jpeg", "bmp", "gif", "tif", "img", "psd", "ppt", "pptx", "odp",
        "txt", "zip", "rtf", "html", "xml","msg", "mp4", "stp", "step", "xt", "csv", "eml"],
    /**
     * Tries to generate the formatted String for the set date in the datePickerModel. Copied from md-date-range-picker.
     * @param datePickerModel the model to generate the formatted String for. Must have a dateStart and dateEnd.
     * @param $filter the angularjs $filter.
     * @returns the formatted date range String.
     */
    formatDateFilterTemplate: function (datePickerModel, $filter) {
        if (impactX.getDateDiff(datePickerModel.dateStart, datePickerModel.dateEnd) === 0) {
            return $filter("date")(datePickerModel.dateStart, "dd MMM yyyy");
        } else {
            return (
                $filter("date")(datePickerModel.dateStart,
                    "dd" + (datePickerModel.dateStart.getMonth() !== datePickerModel.dateEnd.getMonth() ||
                    datePickerModel.dateStart.getFullYear() !== datePickerModel.dateEnd.getFullYear() ? " MMM" : "") +
                    (datePickerModel.dateStart.getFullYear() !== datePickerModel.dateEnd.getFullYear() ? " yyyy" : "")
                ) + " - " + $filter("date")(datePickerModel.dateEnd, "dd MMM yyyy")
            );
        }
    },
    /**
     * Gets the date difference in days. Copied from md-date-range-picker.
     * @param date1 the first date.
     * @param date2 the second date.
     * @returns The date difference in days for the given dates.
     */
    getDateDiff: function (date1, date2) {
        if (!date1 || !date2) return;
        var d1 = new Date(
                date1.getFullYear(),
                date1.getMonth(),
                date1.getDate()
            ),
            d2 = new Date(
                date2.getFullYear(),
                date2.getMonth(),
                date2.getDate()
            );
        return d2 - d1;
    },

    /**
     * Gets the date that is the number of given days in the past.
     * @param days the number of days to go back.
     */
    getDateInPast: function (days) {
        var lessDate = new Date();
        lessDate.setDate(lessDate.getDate() - days + 1);
        lessDate.setHours(0);
        lessDate.setMinutes(0);
        lessDate.setSeconds(0);
        lessDate.setMilliseconds(0);
        return lessDate;
    },

    /**
     * Checks if a given file might be an image.
     * @param fileName name of the file
     * @returns true if image, otherwise false
     */
    isImage: function (fileName) {
        return fileName.match(/\.(jpeg|jpg|gif|png)$/) != null;
    },

    /**
     * Cuts the leading and trailing "/" character, as well as everything from the first number or parameter.
     * @param route the route to format.
     * @returns the formatted route.
     */
    routeForHelpService: function (route) {
        return route.replace(/(^\/)|(\/$)|(\/\d+.*)|(\/:.+)/g, "");
    },
    /**
     * Adds an array with route configurations.
     *
     * @param {*} $routeProvider AngualarJS route provider
     * @param {*} routesObj an object with route configurations {key: path, value: config)
     */
    addRoutes: function ($routeProvider, routesObj) {
        if (this.areAddRouteParametersValid($routeProvider, routesObj)) {
            var attr, routeIdx, confObj, sortedRoutes = [];

            for (attr in routesObj) {
                if (attr && this.isJsObject(routesObj[attr])) {
                    confObj = routesObj[attr];
                    confObj = JSON.parse(JSON.stringify(confObj));
                    confObj.path = attr;
                    checkAngularRoute(confObj);
                    sortedRoutes.push(confObj);

                    this.routeToWorkspaceMapping[attr] = confObj.workspace;
                }
            }

            this.sortPaths(sortedRoutes);

            if (ixUseAngularComponents) {
                this.addWithAngular($routeProvider, sortedRoutes);
            }
            else {
                for (routeIdx=0; routeIdx <sortedRoutes.length; routeIdx++) {
                    obj = sortedRoutes[routeIdx];
                    if(ixBaseURI && obj.templateUrl) {
                        obj.templateUrl = ixBaseURI + obj.templateUrl;
                    }
                    $routeProvider.when(obj.path, obj);
                }
            }
        }
        else {
            try {
                console.error("Failed to add routes", routesObj, $routeProvider);
            }
            catch (e) {

            }
        }
    },
    /**
     * Not public. Checks parameters for some methods in this object
     * @param {*} $routeProvider AngualarJS route provider
     * @param {*} routesObj an object with route configurations {key: path, value: config)
     * @returns true if the parameter are OK.
     */
    areAddRouteParametersValid: function ($routeProvider, routesObj) {
        return (
            this.isJsObject($routeProvider) &&
            this.isFunc($routeProvider.when) &&
            this.isJsObject(routesObj)
        );
    },
    sortPaths: function (arrayOfObjectsWithPaths) {
        arrayOfObjectsWithPaths.sort(function (a, b) {
            var aPath = a.path,
                bPath = b.path;

            if (aPath === bPath) {
                return 0;
            }
            // a.path länger/spezifischer ?
            if (aPath.indexOf(bPath) === 0) {
                return 1;
            }
            // b.path länger/spezifischer ?
            if (bPath.indexOf(aPath) === 0) {
                return -1;
            }
            return aPath.localeCompare(bPath);
        });
    },
    addWithAngular: function ($routeProvider, sortedRoutes) {
        var obj = {
            routeProvider: $routeProvider,
            routes: sortedRoutes,
        };

        if (this.isFunc(this.angularRouteCallback)) {
            this.angularRouteCallback(obj);
            return;
        }
        // Sonst für später speichern.
        this.angularRoutes.push(obj);
    },
    setAngularRouteAddCallback: function (callback) {
        var idx;
        if (this.isFunc(callback)) {
            this.angularRouteCallback = callback;
            for (idx = 0; idx < this.angularRoutes.length; idx++) {
                callback(this.angularRoutes[idx]);
            }
        }
    },
    getWorkspaceByRoutePath: function(path) {
        var result = '';
        if(path && typeof path === 'string') {
            result = this.routeToWorkspaceMapping[path];
        }
        return result || '';
    },
    angularRouteCallback: null,
    angularRoutes: [],
    routeToWorkspaceMapping: {}
};
//Veenion's JavaScript shims
//
(function () {
    //E.g. for AddressPreferencesDialogController
    Array.prototype.move = function (oldIndex, newIndex) {
        if (newIndex >= this.length) {
            var k = newIndex - this.length;
            while (k-- + 1) {
                this.push(undefined);
            }
        }
        this.splice(newIndex, 0, this.splice(oldIndex, 1)[0]);
        return this;
    };
    // Polyfill for isArray
    if (typeof Array.isArray !== "function") {
        Array.isArray = function (vArg) {
            return Object.prototype.toString.call(vArg) === "[object Array]";
        };
    }
})();
